import styled from 'styled-components'

import { BaseButton } from '../buttons'

export const AttachmentActionButton = styled(BaseButton)<{
    $variant: 'add' | 'delete'
}>`
    color: ${(p) =>
        p.$variant == 'add'
            ? p.theme.colors.primaryGreen
            : p.theme.colors.primaryRed};
    border: ${(p) =>
        `1px solid ${
            p.$variant == 'add'
                ? p.theme.colors.primaryGreen
                : p.theme.colors.primaryRed
        }`};
    height: 3em;
    padding: 0.5em;

    &:hover {
        color: ${(p) => p.theme.colors.white};
        background-color: ${(p) =>
            p.$variant == 'add'
                ? p.theme.colors.primaryGreen
                : p.theme.colors.primaryRed};
    }
`
